import { period, randomId } from "../shared";
import type { ExpensePeriod, ExpenseReportStatus } from "../shared";

type PaymentStatus =
  "Awaiting funds" | "Failed" | "In progress" | "Not started" | "Paid";

interface ExpenseItem {
  amountInCents: number;
  consumptionInWattHours: number;
  currency?: string | null;
  IBAN: string;
  id: string;
  paymentStatus?: PaymentStatus;
  period?: ExpensePeriod;
  recipientName: string;
  recipientCrmId: number;
  recipientExternalId?: string;
  reportStatus: ExpenseReportStatus;
}

const IBAN_PAID = "DK5000400440116243";
const IBAN_UNPAID = "DK9520000123456789";

function generateMockExpenseItem({
  id = `exp-${String(randomId())}`,
  ...overrides
}: Partial<ExpenseItem> = {}): ExpenseItem {
  return {
    id,
    recipientName: "Anonymous Payee",
    recipientCrmId: 9000,
    reportStatus: "Pending",
    period: period(2026, 6),
    IBAN: IBAN_UNPAID,
    currency: "DKK",
    amountInCents: 100_00,
    consumptionInWattHours: 60_000,
    ...overrides,
  };
}

export { IBAN_PAID, IBAN_UNPAID, generateMockExpenseItem };
export type { ExpenseItem, PaymentStatus };
